// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d7e7afd7","container":"aeae5ac4","recordName":"d5dec2a8","recordPosition":"e8f8eaa3","archived":"f95e5f5e","recordTeam":"d6e5bddf"};